module.exports = __webpack_public_path__ + "img/video_active.dc5ac88a.svg";